import { render, staticRenderFns } from "./routerTagHoverDown.vue?vue&type=template&id=9fddc1ba&scoped=true&"
import script from "./routerTagHoverDown.vue?vue&type=script&lang=js&"
export * from "./routerTagHoverDown.vue?vue&type=script&lang=js&"
import style0 from "./routerTagHoverDown.vue?vue&type=style&index=0&id=9fddc1ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fddc1ba",
  null
  
)

component.options.__file = "routerTagHoverDown.vue"
export default component.exports